import { forwardRef } from "react"

export const BlockPlanComponenet = forwardRef(({ blockID }, ref) => {
  if (blockID === "E") {
    return <BlockE ref={ref} />
  } else if (blockID === "C") {
    return <BlockC ref={ref} />
  } else if (blockID === "D") {
    return <BlockD ref={ref} />
    // return <BuildingPlans.BlockE ref={svgref} />
  } else return null
})

export const BlockD = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      viewBox="0 0 494.06 353.28"
      width="100%"
    >
      <g id="d-block-zoom">
        <path
          d="M337.42.36,169.75,0q-.1,44.66-.19,89.31l-.33,145.2,167.38-.65Q337,117.12,337.42.36Z"
          fill="#5c7f66"
          opacity="0.3"
        />
        <circle cx="253.33" cy="121.83" r="50.58" fill="#cfc5c6" />
      </g>
      <g id="block_d">
        <g id="static_element">
          <g id="building_outlines">
            <polyline
              points="4.31 14.22 140.29 14.22 141.16 177.05 28.61 178.11 28.1 143.99 1.73 143.99 1.73 77.29 14.14 77.29 14.14 40.59 4.31 40.59 4.31 14.22"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <polyline
              points="17.2 178.11 141.16 177.05 142.16 346.95 16.95 346.95 17.2 178.11"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <rect
              x="142.17"
              y="274.75"
              width="222.89"
              height="72.2"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <polygon
              points="380.44 156.52 492.28 155.97 492.28 180.58 474.68 180.58 474.68 218.68 492.28 218.68 492.28 346.95 365.44 346.95 364.02 203.55 379.82 203.55 380.44 156.52"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.56"
            />
            <polyline
              points="363.86 14.22 492.44 14.22 492.44 155.97 364.82 157.71 363.86 14.22"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(117.75 169.08)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              5
            </text>
            <text
              transform="translate(117 339.19)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              4
            </text>
            <text
              transform="translate(337.63 339.19)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              3
            </text>
            <text
              transform="translate(465.68 339.19)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              2
            </text>
            <text
              transform="translate(462.04 142.05)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              1
            </text>
            <text
              transform="translate(225.87 142.97)"
              fontSize="78.13"
              fill="#887597"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              D
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  id="apt_no_d5"
                  transform="translate(60.48 118.47)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_d4"
                  transform="translate(60.48 292.07)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_d3"
                  transform="translate(228.24 336.23)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_d2"
                  transform="translate(404.96 292.07)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_d1"
                  transform="translate(405.83 109.22)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <polyline
              id="building_button_d4"
              points="17.2 178.11 141.16 177.05 142.16 346.95 16.95 346.95 17.2 178.11"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <polyline
              id="building_button_d5"
              points="4.31 14.22 140.29 14.22 141.16 177.05 28.61 178.11 28.1 143.99 1.73 143.99 1.73 77.29 14.14 77.29 14.14 40.59 4.31 40.59 4.31 14.22"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <rect
              id="building_button_d3"
              x="142.17"
              y="274.75"
              width="222.89"
              height="72.2"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
            <polygon
              id="building_button_d2"
              points="380.44 156.52 492.28 155.97 492.28 180.58 474.68 180.58 474.68 218.68 492.28 218.68 492.28 346.95 365.44 346.95 364.02 203.55 379.82 203.55 380.44 156.52"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.56"
            />
            <polyline
              id="building_button_d1"
              points="363.86 14.22 492.44 14.22 492.44 155.97 364.82 157.71 363.86 14.22"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})

export const BlockC = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      viewBox="0 0 532.92 340.92"
      width="100%"
    >
      <g id="block_c">
        <g id="static_element">
          <g id="green_space">
            <polygon
              id="green_space-2"
              data-name="green_space"
              points="323.32 122.34 322.85 334.09 155.18 332.86 155.65 121.98 323.32 122.34"
              fill="#5c7f66"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2">
            <circle cx="238.69" cy="228.03" r="50.58" fill="#cfc5c6" />
          </g>
          <g id="building_outlines">
            <polygon
              points="1.5 2.5 125.26 2.27 125.25 145.2 111.6 145.18 111.44 168.78 1.5 169.2 1.5 2.5"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="125.9 2.32 125.89 75.73 349.26 75.73 349.33 2.55 125.9 2.32"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="348.69 1.5 473.77 1.5 473.77 167.01 364.43 167.12 364.43 143.45 348.65 143.45 348.69 1.5"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              points="16.55 169.87 111.44 170.41 111.29 191.62 125.25 191.68 125.25 334.16 1.5 334.16 1.5 206.62 16.78 206.39 16.55 169.87"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polyline
              points="364.46 167 458.02 166.89 458.02 205.21 473.74 205.14 473.77 327.43 348.65 327.43 348.65 190.46 364.43 190.46 364.46 167"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(84.15 159.04)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              4
            </text>
            <text
              transform="translate(322.56 69.01)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              5
            </text>
            <text
              transform="translate(446.85 154.76)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              1
            </text>
            <text
              transform="translate(100.54 325.68)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              3
            </text>
            <text
              transform="translate(446.85 318.45)"
              fontSize="33.02"
              fill="#887597"
              fontFamily="NotoSans-Bold, Noto Sans"
              fontWeight="700"
            >
              2
            </text>
            <text
              transform="translate(209.04 252.01)"
              fontSize="78.13"
              fill="#887597"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              C
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  id="apt_no_c4"
                  transform="translate(46.79 109.15)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c5"
                  transform="translate(214.54 66.19)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c1"
                  transform="translate(391.27 109.15)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c3"
                  transform="translate(47.27 279.09)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
                <text
                  id="apt_no_c2"
                  transform="translate(392.14 278.61)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <polygon
              id="building_button_c4"
              points="1.5 2.5 125.26 2.27 125.25 145.2 111.6 145.18 111.44 168.78 1.5 169.2 1.5 2.5"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c5"
              points="125.9 2.32 125.89 75.73 349.26 75.73 349.33 2.55 125.9 2.32"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c1"
              points="348.69 1.5 473.77 1.5 473.77 167.01 364.43 167.12 364.43 143.45 348.65 143.45 348.69 1.5"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polygon
              id="building_button_c3"
              points="16.55 169.87 111.44 170.41 111.29 191.62 125.25 191.68 125.25 334.16 1.5 334.16 1.5 206.62 16.78 206.39 16.55 169.87"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
            <polyline
              id="building_button_c2"
              points="364.46 167 458.02 166.89 458.02 205.21 473.74 205.14 473.77 327.43 348.65 327.43 348.65 190.46 364.43 190.46 364.46 167"
              fill="#c6c6c6"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.46"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})
export const BlockE = forwardRef((props, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      viewBox="0 0 532.92 340.92"
      width="100%"
    >
      <g id="block_e">
        <g id="static_element">
          <g id="green_space">
            <path
              d="M397.87,98.84l-280-.62-.5,57.18H103.75q.19,19.75.42,39.51l308.38,34.64Z"
              fill="#5c7f66"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2">
            <circle cx="259.39" cy="155.5" r="50.58" fill="#cfc5c6" />
          </g>
          <g id="building_outlines">
            <path
              d="M450.86,310.26,438,142.18l12.82,168.08L508,320.57,495.4,140.05,421,142.18,422.58,158q4.94,47.24,9.88,94.48h.08l13.62,2.58-13.62-2.58h-.08q-4.93-47.25-9.88-94.48l9.24,94.48L82.3,207.63l-.63-66.43-13-.41,1.7,94-1.7-94L9.47,139l59.18,1.82,13,.41,15.93,0,.14-59.16,317.48.69L421,142.18l74.37-2.13L486.65,15,9.74,11.19l-.51,237L70.3,259.78l0-25,13.57.36,0,25.12,341,48.27,5.14-25.44,17,0,3.35,27.16L508,320.57ZM355.21,82.63,353.68,14Z"
              fill="none"
              stroke="#643287"
              strokeMiterlimit="10"
              strokeWidth="3.39"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(235.01 179.48)"
              fontSize="78.13"
              fill="#887597"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              E
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="text-type-1">
              <g id="dynamic_value">
                <text
                  id="apt_no_e"
                  transform="translate(342.27 179.48)"
                  fontSize="60"
                  fill="#887597"
                  fontFamily="Lora-Bold, Lora"
                  fontWeight="700"
                >
                  0
                </text>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <rect
              id="building_button_e1"
              width="532.92"
              height="340.92"
              fill="#887597"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})

export const SvgSitePlan = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 722.37 1171.4"
      //   width="722.37"
      height="100%"
      {...props}
    >
      <g id="block_b">
        <g id="static_element">
          <g id="green_space">
            <path
              id="grass"
              d="M416.77,211.6l-97-.21-.12,51.67-.18,84,97.94.71Q417.1,279.69,416.77,211.6Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2">
            <circle
              cx="669.91"
              cy="316.63"
              r="50.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="building_outlines">
            <path
              d="M504.75,218.62l-.43,196.67-74,.11V405.21l-23,.14v16l-81.42-.18V405.52l-21.58-.39v10.25l-79-.42L222.75,218l80.63.18V376.13h18v-17l92,1.2v16l16.5-.46q-.15-78.72-.29-157.45Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              d="M483.41,315.51l.22-97"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <path
              d="M504.54,317.06,430,316.9"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <path
              d="M430.34,405.21q-.21-14.65-.43-29.31"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              d="M303.94,415.12l-.27-39.62"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <path
              d="M303.54,315.62l-80-.17"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="text-type-2">
            <text
              transform="translate(645.78 340.61)"
              fontSize="78.13"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              B
            </text>
          </g>
        </g>
        <g id="dynamic_element">
          <g id="dynamic_display">
            <g id="icon-type-1">
              <circle
                id="circle"
                cx="59.39"
                cy="316.63"
                r="50.58"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit="10"
              />
            </g>
            <g id="text-type-1">
              <g id="dynamic_value">
                <g id="apt_no_b">
                  <text
                    transform="translate(36.25 340.61)"
                    fontSize="78.13"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit="10"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons">
          <g id="return_parent_id">
            <rect
              id="interactive_element"
              x="208.73"
              y="202.9"
              width="319.42"
              height="228.31"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
      <g id="block_a">
        <g id="static_element-2" data-name="static_element">
          <g id="green_space-2" data-name="green_space">
            <path
              d="M416.83,76.05l-.67,121.4h0l-96.6.39.27-122Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2-2" data-name="icon-type-2">
            <circle
              cx="669.66"
              cy="98.35"
              r="50.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="building_outlines-2" data-name="building_outlines">
            <path
              d="M505,8.24l-.39,179.45-73.69-.16.18-84.38,7.7-1v-26l-7.68-.87.27-38.65-21.5.45-.06,26.84h-83l.05-22h-22l-.32,145.45-80.21-.18.22-99.09,12.21-.33v-19h-14l.09-41h7l-.27-20,75.81.66v-7L339.26,1l-.4,7h19v6h20V8h19V2l34.5-.43v6Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              x1="431.48"
              y1="7.58"
              x2="431.41"
              y2="36.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <path
              d="M504.8,89.2l-66-.15"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <polyline
              points="482.58 187.2 483.58 187.2 482.8 89.2 483.8 89.2"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <path
              d="M304.8,88.3l-80-.17"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <line
              x1="305.49"
              y1="0.81"
              x2="305.4"
              y2="41.81"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="text-type-2-2" data-name="text-type-2">
            <text
              transform="translate(643.57 119.5)"
              fontSize="78.13"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              A
            </text>
          </g>
        </g>
        <g id="dynamic_element-2" data-name="dynamic_element">
          <g id="dynamic_display-2" data-name="dynamic_display">
            <g id="icon-type-1-2" data-name="icon-type-1">
              <circle
                id="circle-2"
                data-name="circle"
                cx="59.14"
                cy="98.35"
                r="50.58"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit="10"
              />
            </g>
            <g id="text-type-1-2" data-name="text-type-1">
              <g id="dynamic_value-2" data-name="dynamic_value">
                <g id="apt_no_a">
                  <text
                    transform="translate(34.3 119.5)"
                    fontSize="78.13"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit="10"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons-2" data-name="hidden_buttons">
          <g id="return_parent_id-2" data-name="return_parent_id">
            <rect
              id="button"
              x="209.83"
              y="0.81"
              width="319.42"
              height="197.03"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
      <g id="block_c">
        <g id="static_element-3" data-name="static_element">
          <g id="green_space-3" data-name="green_space">
            <polygon
              points="417.57 579.86 417.3 702.36 320.3 701.65 320.57 579.65 417.57 579.86"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2-3" data-name="icon-type-2">
            <circle
              cx="671.29"
              cy="606.77"
              r="50.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="building_outlines-3" data-name="building_outlines">
            <line
              x1="295.49"
              y1="606.14"
              x2="239.95"
              y2="606.41"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.85"
            />
            <line
              x1="494.5"
              y1="605.63"
              x2="441.33"
              y2="605.89"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1.81"
            />
            <line
              x1="302.99"
              y1="509.82"
              x2="302.99"
              y2="551.59"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              x1="432.23"
              y1="510.78"
              x2="432.23"
              y2="552.54"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <path
              d="M231.39,607.27V510h273.2V605.7h-9.11v22.17l9.09,0,0,70.75H432.21V619.34h9.12V592.07h-9.12V552.29H303v40.22l-7.89,0-.18,26.5,8.07,0v82.42H231.39V627.67l8.84-.13q-.06-10.56-.13-21.13l-8.71,0"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
          </g>
          <g id="text-type-2-3" data-name="text-type-2">
            <text
              transform="translate(641.65 630.75)"
              fontSize="78.13"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              C
            </text>
          </g>
        </g>
        <g id="dynamic_element-3" data-name="dynamic_element">
          <g id="dynamic_display-3" data-name="dynamic_display">
            <g id="icon-type-1-3" data-name="icon-type-1">
              <circle
                cx="60.77"
                cy="606.77"
                r="50.58"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit="10"
              />
            </g>
            <g id="text-type-1-3" data-name="text-type-1">
              <g id="dynamic_value-3" data-name="dynamic_value">
                <g id="apt_no_c">
                  <text
                    transform="translate(33.18 630.75)"
                    fontSize="78.13"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit="10"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons-3" data-name="hidden_buttons">
          <g id="return_parent_id-3" data-name="return_parent_id">
            <rect
              id="button_c"
              x="209.83"
              y="496.69"
              width="319.42"
              height="214.1"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
      <g id="block_d">
        <g id="static_element-4" data-name="static_element">
          <g id="green_space-4" data-name="green_space">
            <path
              d="M417.72,712.44l-97-.21q-.06,25.83-.11,51.67l-.19,84,96.83-.38Q417.49,780,417.72,712.44Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2-4" data-name="icon-type-2">
            <circle
              cx="661.6"
              cy="803.75"
              r="50.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="building_outlines-4" data-name="building_outlines">
            <line
              x1="304.76"
              y1="871.17"
              x2="304.76"
              y2="912.94"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              x1="304.76"
              y1="814.65"
              x2="239.64"
              y2="814.97"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2.5"
            />
            <polyline
              points="433.25 803.46 432.7 720.45 507.08 720.45 507.08 816.7 496.9 816.7 496.9 838.74 507.08 838.74 507.08 912.94 232.32 912.94 232.47 815.27 239.65 815.27 239.35 795.53 224.09 795.53 224.09 756.94 231.27 756.94 231.27 735.71 225.59 735.71 225.59 720.45 304.25 720.45 304.75 871.17 433.7 871.17 433.42 829.38"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <polyline
              points="432.88 829.98 442.02 829.98 442.02 802.91 432.26 802.91"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2.06"
            />
            <line
              x1="433.7"
              y1="871.17"
              x2="433.7"
              y2="912.94"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              x1="506.91"
              y1="802.75"
              x2="441.79"
              y2="803.07"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2.5"
            />
          </g>
          <g id="text-type-2-4" data-name="text-type-2">
            <text
              transform="translate(634.15 824.9)"
              fontSize="78.13"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              D
            </text>
          </g>
        </g>
        <g id="dynamic_element-4" data-name="dynamic_element">
          <g id="dynamic_display-4" data-name="dynamic_display">
            <g id="icon-type-1-4" data-name="icon-type-1">
              <circle
                cx="51.08"
                cy="803.75"
                r="50.58"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit="10"
              />
            </g>
            <g id="text-type-1-4" data-name="text-type-1">
              <g id="dynamic_value-4" data-name="dynamic_value">
                <g id="apt_no_d">
                  <text
                    transform="translate(28.45 824.9)"
                    fontSize="78.13"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit="10"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons-4" data-name="hidden_buttons">
          <g id="return_parent_id-4" data-name="return_parent_id">
            <rect
              id="button_d"
              x="208.73"
              y="715.75"
              width="319.42"
              height="214.1"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
      <g id="block_e">
        <g id="static_element-5" data-name="static_element">
          <g id="green_space-5" data-name="green_space">
            <path
              d="M464.34,1039.54l-165-.36-.3,33.69h-8q.12,11.64.25,23.28L473,1116.56Z"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              opacity="0.3"
            />
          </g>
          <g id="icon-type-2-5" data-name="icon-type-2">
            <circle
              id="block_e-2"
              data-name="block_e"
              cx="669.44"
              cy="1072.66"
              r="50.58"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="building_outlines-5" data-name="building_outlines">
            <polyline
              points="488.68 1065.08 496.3 1164.11 530.28 1170.19 522.83 1063.82 478.51 1065.08 485.37 1130.09 493.27 1130.09"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <polygon
              points="516.65 990.16 529.25 1170.19 495.27 1164.11 493.3 1148.11 483.3 1148.09 480.27 1163.08 279.33 1134.64 279.36 1119.84 271.36 1119.63 271.33 1134.37 235.35 1127.55 235.65 987.9 516.65 990.16"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <polygon
              points="474.56 1030.07 287.5 1029.66 287.42 1064.52 278.03 1064.5 278.4 1103.64 484.34 1130.09 474.56 1030.07"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="2"
            />
            <line
              x1="438.3"
              y1="989.53"
              x2="439.2"
              y2="1029.99"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <polyline
              points="278.03 1064.5 270.36 1064.26 235.49 1063.19"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
            <line
              x1="271.36"
              y1="1119.62"
              x2="270.36"
              y2="1064.26"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
          <g id="text-type-2-5" data-name="text-type-2">
            <text
              transform="translate(645.06 1096.64)"
              fontSize="78.13"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
              fontFamily="Lora-Bold, Lora"
              fontWeight="700"
            >
              E
            </text>
          </g>
        </g>
        <g id="dynamic_element-5" data-name="dynamic_element">
          <g id="dynamic_display-5" data-name="dynamic_display">
            <g id="icon-type-1-5" data-name="icon-type-1">
              <circle
                id="apt_e"
                cx="58.91"
                cy="1072.66"
                r="50.58"
                fill="#fff"
                stroke="#000"
                strokeMiterlimit="10"
              />
            </g>
            <g id="text-type-1-5" data-name="text-type-1">
              <g id="dynamic_value-5" data-name="dynamic_value">
                <g id="apt_no_e">
                  <text
                    transform="translate(34.08 1096.64)"
                    fontSize="78.13"
                    fill="#fff"
                    stroke="#000"
                    strokeMiterlimit="10"
                    fontFamily="Lora-Bold, Lora"
                    fontWeight="700"
                  >
                    0
                  </text>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="hidden_buttons-5" data-name="hidden_buttons">
          <g id="return_parent_id-5" data-name="return_parent_id">
            <rect
              id="button_e"
              x="209.83"
              y="968.44"
              width="319.42"
              height="202.44"
              fill="#fff"
              stroke="#000"
              strokeMiterlimit="10"
            />
          </g>
        </g>
      </g>
    </svg>
  )
})
